import React, {Component} from 'react';
import classNames from 'classnames';
import * as formatter from "../../utils/formatters"

class OperationalPortfolioStatus extends Component{

  constructor(props){
    super(props);
    this.state={data:this.props.data}
  }

  render(){
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.striped,
      'table-bordered': this.props.bordered,
      'table-hover': this.props.hover,
      'table-condensed': this.props.condensed
    });

    let rows = this.props.data.map( info => {
      return <tr><th>{info.type}</th><td>{formatter.formatNumber(info.quantity)}</td></tr>
    });

    return(
      <table className={tableClass}>
        <tbody>
          {rows}
        </tbody>
      </table>
    );
  }
}

export default OperationalPortfolioStatus;



// WEBPACK FOOTER //
// ./src/components/tables/operationalPortfolioStatus.js